import backendAxios from '../utils/backendAxios';

// "Servicios que imparto": lo que la persona imparte (o le pidieron impartir) en páginas de otras personas.

// { ok, colaboraciones: [{ pagina, dueno, invitacionAlEquipo, servicios: [{ ..., estado, visible }] }], pendientes }
export const getColaboraciones = async () => {
  try {
    const res = await backendAxios.get('/api/colaboraciones');
    return {
      ok: true,
      colaboraciones: Array.isArray(res.data?.colaboraciones) ? res.data.colaboraciones : [],
      pendientes: res.data?.pendientes || 0,
    };
  } catch (err) {
    return { ok: false, colaboraciones: [], pendientes: 0 };
  }
};

// accion: 'aceptar' | 'rechazar' | 'dejar'. Sin servicioId responde la invitación a la página.
export const responderColaboracion = async (pageId, servicioId, accion) => {
  try {
    const res = await backendAxios.post(`/api/colaboraciones/${pageId}/responder`, { servicioId: servicioId || undefined, accion });
    return { ok: true, estado: res.data.estado };
  } catch (err) {
    return { ok: false, error: err.response?.data?.msg || 'No se pudo guardar tu respuesta. Inténtalo de nuevo.' };
  }
};
